module.exports = __webpack_public_path__ + "img/logo-ch.a96592a4.png";